<div [formGroup]="parentForm">
	<div formGroupName="{{nestedFormGroupName}}">
		<div formGroupName="{{jawFormControlName}}">
			<label>{{(isUpperJaw ? 'Upper jaw' : 'Lower jaw') | translate}}</label>
			<div class="options-grid">
				<mat-checkbox formControlName="scheuProtocol">{{ "according to Scheu protocol" | translate}}</mat-checkbox>
				<label>{{"labial/buccal" | translate}}</label>
				<mat-form-field>
					<input matInput formControlName="{{labialBuccalFormControlName}}">
					<mat-error>{{"please fill in" | translate}}</mat-error>
				</mat-form-field>
				<label>{{"lingual/palatal" | translate}}</label>
				<mat-form-field>
					<input matInput formControlName="{{lingualPalatalFormControlName}}">
					<mat-error>{{"please fill in" | translate}}</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
</div>
